import gql from "graphql-tag";
import { useQuery } from "react-apollo";

import { ALL_COMPANY_POSTING_PERIODS_QUERY } from "../../../../graphql/CompanyPostingPeriods/CompanyPostingPeriods.graphql";

const ALL_SYSTEM_CODES_QUERY = gql`
  query SystemCodes($where: SystemCodeWhereInput!) {
    SystemCodes(where: $where) {
      RecId
      Type
      Category
      CodeName
      CodeId
      CodeDescription
    }
  }
`;

export function useCanPostWorkOrder(completeDate) {
  const { data: PostingModulesData } = useQuery(ALL_SYSTEM_CODES_QUERY, {
    variables: {
      where: {
        CodeName: "PostingModule",
        Category: "PostingPeriods",
        CodeId: "I"
      }
    }
  });

  const { data: PostingPeriodsData } = useQuery(
    ALL_COMPANY_POSTING_PERIODS_QUERY,
    {
      variables: {
        where: {
          Open: true,
          ModuleRecIdRef: PostingModulesData?.SystemCodes[0]?.RecId
        }
      },
      fetchPolicy: "network-only"
    }
  );

  const OpenInventoryCompanyPostingPeriod =
    PostingPeriodsData?.CompanyPostingPeriods[0];

  if (!OpenInventoryCompanyPostingPeriod?.PeriodEndDateTime) return false;

  const openPeriodEndDate = new Date(
    OpenInventoryCompanyPostingPeriod.PeriodEndDateTime
  );

  if (!completeDate) return false;

  if (!openPeriodEndDate) return false;

  if (new Date(completeDate) > openPeriodEndDate) return false;

  return true;
}
